import styled from "@emotion/styled";
import MainCard from "../elements/MainCard";
import t from "../../../helper/t";

const RootDiv = styled(MainCard)(({ theme }) => ([
    {
        display: "grid",
        gridTemplateColumns: "1fr 1fr",

        paddingLeft: 32,
        paddingRight: 16,
        paddingTop: 16,
        paddingBottom: 16,

        columnGap: 80,

        /* for mobile */
        [theme.splus3.breakpoints.mobile]: {
            display: "flex",
            flexDirection: "column",
            padding: 0,
        },
    }
]));

const TextSegmentDiv = styled.div(({ theme }) => ([
    {
        display: "flex",
        flexDirection: "column",
        alignSelf: "center",

        /* for mobile */
        [theme.splus3.breakpoints.mobile]: {
            alignSelf: "start",
        },
    }
]));

const TextH3Div = styled.div(({ theme }) => ([
    theme.splus3.foreground.monochrome600,
    theme.splus3.typography.h3,
    {
        /* for mobile */
        [theme.splus3.breakpoints.mobile]: [
            theme.splus3.foreground.monochrome500,
            theme.splus3.typography.font16Bold,
            {
            }
        ],
    }
]));

const BodyText = styled.div(({ theme }) => ([
    theme.splus3.foreground.monochrome600,
    theme.splus3.typography.default,
    {
        marginTop: 12,
        marginBottom: 24,
        maxWidth: 463,

        /* for mobile */
        [theme.splus3.breakpoints.mobile]: [
            theme.splus3.foreground.monochrome500,
            theme.splus3.typography.font16Lite,
            {
                marginBottom: 12,
            }
        ],
    }
]));

const VideoContainer = styled.div([
    {
        display: "flex",
        alignItems: "center",
        minHeight: 320,
    }
]);

const VideoResponsiveFrame = styled.iframe([
    {
        width: "100%",
        aspectRatio: "16 / 9",
    }
]);

interface VideoCardProps {

}

const VideoCard: React.FC<VideoCardProps> = () => {
    return (
        <RootDiv>
            <TextSegmentDiv>
                <TextH3Div>
                    {t("Video: Das musst Du wissen")}
                </TextH3Div>
                <BodyText>
                    {t("Schau Dir das Video an. Wir zeigen Dir, was Du beachten musst. Und erklären Dir, wie der Speedtest abläuft und welche Besonderheiten er hat.")}
                </BodyText>
            </TextSegmentDiv>

            <VideoContainer>
                <VideoResponsiveFrame
                    src="https://www.youtube.com/embed/lEcI_DrUqBU"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    title="Vodafone Speedtest Plus: WLAN verbessern I ServiceZoom">
                </VideoResponsiveFrame>
            </VideoContainer>
        </RootDiv>
    )
}

export default VideoCard;